import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from 'minimal-shared/utils';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';
import { fileData, fileThumb } from './utils';
import { fileThumbnailClasses } from './classes';
import { RemoveButton, DownloadButton } from './action-buttons';

// ----------------------------------------------------------------------

export function FileThumbnail(t0) {
  const $ = _c(31);
  let className;
  let file;
  let mediaPreview;
  let onDownload;
  let onRemove;
  let other;
  let ref;
  let slotProps;
  let sx;
  let tooltip;
  if ($[0] !== t0) {
    ({
      ref,
      file,
      tooltip,
      onRemove,
      mediaPreview,
      slotProps,
      onDownload,
      className,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = file;
    $[3] = mediaPreview;
    $[4] = onDownload;
    $[5] = onRemove;
    $[6] = other;
    $[7] = ref;
    $[8] = slotProps;
    $[9] = sx;
    $[10] = tooltip;
  } else {
    className = $[1];
    file = $[2];
    mediaPreview = $[3];
    onDownload = $[4];
    onRemove = $[5];
    other = $[6];
    ref = $[7];
    slotProps = $[8];
    sx = $[9];
    tooltip = $[10];
  }
  let t1;
  let t2;
  if ($[11] !== className || $[12] !== file || $[13] !== mediaPreview || $[14] !== onDownload || $[15] !== onRemove || $[16] !== other || $[17] !== ref || $[18] !== slotProps || $[19] !== sx || $[20] !== tooltip) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        src,
        name,
        format
      } = fileData(file);
      let t3;
      if ($[23] !== slotProps) {
        t3 = slotProps ?? {};
        $[23] = slotProps;
        $[24] = t3;
      } else {
        t3 = $[24];
      }
      const {
        icon,
        removeBtn,
        downloadBtn,
        tooltip: tooltipProps
      } = t3;
      const renderItem = () => <ItemRoot ref={ref} className={mergeClasses([fileThumbnailClasses.root, className])} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}>{["image", "video"].includes(format) && mediaPreview ? <ItemMediaPreview src={src} className={fileThumbnailClasses.media} component={format === "video" ? "video" : "img"} {...slotProps?.media} /> : <ItemIcon src={fileThumb(format)} className={fileThumbnailClasses.icon} {...icon} />}{onRemove && <RemoveButton onClick={onRemove} className={fileThumbnailClasses.removeBtn} {...removeBtn} />}{onDownload && <DownloadButton onClick={onDownload} className={fileThumbnailClasses.downloadBtn} {...downloadBtn} />}</ItemRoot>;
      if (tooltip) {
        const t4 = tooltipProps?.slotProps;
        let t5;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = [{
            name: "offset",
            options: {
              offset: [0, -12]
            }
          }];
          $[25] = t5;
        } else {
          t5 = $[25];
        }
        const t6 = tooltipProps?.slotProps?.popper;
        let t7;
        if ($[26] !== t6) {
          t7 = {
            modifiers: t5,
            ...t6
          };
          $[26] = t6;
          $[27] = t7;
        } else {
          t7 = $[27];
        }
        let t8;
        if ($[28] !== t4 || $[29] !== t7) {
          t8 = {
            ...t4,
            popper: t7
          };
          $[28] = t4;
          $[29] = t7;
          $[30] = t8;
        } else {
          t8 = $[30];
        }
        t2 = <Tooltip arrow={true} title={name} {...tooltipProps} slotProps={t8}>{renderItem()}</Tooltip>;
        break bb0;
      }
      t1 = renderItem();
    }
    $[11] = className;
    $[12] = file;
    $[13] = mediaPreview;
    $[14] = onDownload;
    $[15] = onRemove;
    $[16] = other;
    $[17] = ref;
    $[18] = slotProps;
    $[19] = sx;
    $[20] = tooltip;
    $[21] = t1;
    $[22] = t2;
  } else {
    t1 = $[21];
    t2 = $[22];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
}
const ItemRoot = styled('span')(({
  theme
}) => ({
  width: 36,
  height: 36,
  flexShrink: 0,
  alignItems: 'center',
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius * 1.25
}));
const ItemIcon = styled('img')(() => ({
  width: '100%',
  height: '100%'
}));
const ItemMediaPreview = styled(CardMedia)(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 'inherit'
}));